import { Component, OnInit } from '@angular/core';

import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';

import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { Tc } from 'src/app/components/core/_infrastructure/types/common';
import { WAccionesPerfilTipoEstadoViewModel, TwTcAccionesViewModel } from './accionesperfiltipoestado.types';
import { AccionesPerfilTipoEstadoService } from './accionesperfiltipoestado.service';

@Component({
    selector: 'app-accionesperfiltipoestado-edit',
    templateUrl: './accionesperfiltipoestado-edit.component.html',
})
export class AccionesPerfilTipoEstadoEditComponent extends ComponentBase implements OnInit {
    editMode: boolean;
    editTitle = 'Nuevo';

    listModulos: Tc[];
    listAcciones: Tc[];
    listPerfil: Tc[];
    listEstado: Tc[];
    listTipo: Tc[];
    listSubTipo: Tc[];

    accion: TwTcAccionesViewModel;
    accionesPerfilTipoEstado: WAccionesPerfilTipoEstadoViewModel;
    visibilitySpinner = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private accionesPerfilTipoEstadoService: AccionesPerfilTipoEstadoService,
    ) {
        super(authService, notificationService, exceptionHandler);
        this.accionesPerfilTipoEstado = new WAccionesPerfilTipoEstadoViewModel();
        this.accion = new TwTcAccionesViewModel();
    }

    ngOnInit(): void {
        this.globalService.getTipoModulosImporComunes().subscribe(res => {
            this.listModulos = res;
        });
        this.globalService.getPerfilesUsuario().subscribe(res => {
            this.listPerfil = res;
        });
        this.globalService.getEstadoSolicitud().subscribe(res => {
            this.listEstado = res;
        });
        this.globalService.getTipoSolicitud().subscribe(res => {
            this.listTipo = res;
        });
        this.globalService.getSubTipoSolicitud().subscribe(res => {
            this.listSubTipo = res;
        });

        this.createForm();

        let id = +this.activatedRoute.snapshot.params['id'];

        if (id) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.accionesPerfilTipoEstadoService.getAccionesPerfilTipoEstadoById(id).subscribe(result => {
                this.accionesPerfilTipoEstado = result;

                this.globalService.getAccionesByModulo(result.IdModulo!).subscribe(res => {
                    this.listAcciones = res;
                });

                this.updateForm();

                this.accionesPerfilTipoEstadoService.getAccionById(this.accionesPerfilTipoEstado.IdAccion!).subscribe(result => {
                    this.accion = result;
                    if (this.accion.Estado) {
                        this.form.controls['IdEstado'].enable();
                    } else {
                        this.form.controls['IdEstado'].disable();
                        this.form.patchValue({
                            IdEstado: null,
                        });
                    }
                    if (this.accion.Tipo) {
                        this.form.controls['IdTipo'].enable();
                    } else {
                        this.form.controls['IdTipo'].disable();
                        this.form.patchValue({
                            IdTipo: null,
                        });
                    }
                    if (this.accion.Subtipo) {
                        this.form.controls['IdSubtipo'].enable();
                    } else {
                        this.form.controls['IdSubtipo'].disable();
                        this.form.patchValue({
                            IdSubtipo: null,
                        });
                    }
                });
            });
        }
    }

    createForm(): void {
        this.form = this.fb.group({
            IdModulo: [null, Validators.required],
            IdAccion: [null, Validators.required],
            IdPerfil: [null, Validators.required],
            IdEstado: null,
            IdTipo: null,
            IdSubtipo: null,
            Edicion: [false, Validators.required],
        });
    }

    updateForm(): void {
        this.form.setValue({
            IdModulo: this.accionesPerfilTipoEstado.IdModulo,
            IdAccion: this.accionesPerfilTipoEstado.IdAccion,
            IdPerfil: this.accionesPerfilTipoEstado.IdPerfil,
            IdEstado: this.accionesPerfilTipoEstado.IdEstado,
            IdTipo: this.accionesPerfilTipoEstado.IdTipo,
            IdSubtipo: this.accionesPerfilTipoEstado.IdSubtipo,
            Edicion: this.accionesPerfilTipoEstado.Edicion,
        });
    }

    onSelectModulo(): void {
        const idModulo = this.form.value.IdModulo;

        this.globalService.getAccionesByModulo(idModulo).subscribe(res => {
            this.listAcciones = res;
        });

        this.form.patchValue({
            IdAccion: null,
        });
    }

    onSelectTipo(): void {
        if (this.form.value.IdTipo == null) {
            this.form.controls['IdSubtipo'].enable();
        } else {
            this.form.patchValue({
                IdSubtipo: null,
            });
            this.form.controls['IdSubtipo'].disable();
        }
    }

    onSelectSubtipo(): void {
        if (this.form.value.IdSubtipo == null) {
            this.form.controls['IdTipo'].enable();
        } else {
            this.form.patchValue({
                IdTipo: null,
            });
            this.form.controls['IdTipo'].disable();
        }
    }

    onSelectAccion(): void {
        if (this.form.value.IdAccion == null) {
            this.form.controls['IdEstado'].enable();
            this.form.controls['IdTipo'].enable();
            this.form.controls['IdSubtipo'].enable();
            this.form.patchValue({
                IdEstado: null,
                IdTipo: null,
                IdSubtipo: null,
            });
        } else {
            this.accionesPerfilTipoEstadoService.getAccionById(this.form.value.IdAccion).subscribe(result => {
                this.accion = result;
                if (this.accion.Estado) {
                    this.form.controls['IdEstado'].enable();
                } else {
                    this.form.controls['IdEstado'].disable();
                    this.form.patchValue({
                        IdEstado: null,
                    });
                }
                if (this.accion.Tipo) {
                    this.form.controls['IdTipo'].enable();
                } else {
                    this.form.controls['IdTipo'].disable();
                    this.form.patchValue({
                        IdTipo: null,
                    });
                }
                if (this.accion.Subtipo) {
                    this.form.controls['IdSubtipo'].enable();
                } else {
                    this.form.controls['IdSubtipo'].disable();
                    this.form.patchValue({
                        IdSubtipo: null,
                    });
                }
            });
        }
    }

    onSubmit(): void {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        this.visibilitySpinner = true;

        let accionesPerfilTipoEstado = new WAccionesPerfilTipoEstadoViewModel();

        accionesPerfilTipoEstado.IdModulo = this.form.value.IdModulo;
        accionesPerfilTipoEstado.IdAccion = this.form.value.IdAccion;
        accionesPerfilTipoEstado.IdPerfil = this.form.value.IdPerfil;
        accionesPerfilTipoEstado.IdEstado = this.form.value.IdEstado;
        accionesPerfilTipoEstado.IdTipo = this.form.value.IdTipo;
        accionesPerfilTipoEstado.IdSubtipo = this.form.value.IdSubtipo;
        accionesPerfilTipoEstado.Edicion = this.form.value.Edicion;

        accionesPerfilTipoEstado.Id = this.accionesPerfilTipoEstado.Id;

        if (this.editMode) {
            this.accionesPerfilTipoEstadoService.editAccionesPerfilTipoEstado(accionesPerfilTipoEstado).subscribe({
                next: () => {
                    this.addSuccessMessage('Permiso de Acción modificado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        } else {
            this.accionesPerfilTipoEstadoService.createAccionesPerfilTipoEstado(accionesPerfilTipoEstado).subscribe({
                next: () => {
                    this.addSuccessMessage('Permiso de Acción añadido correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    onBack(): void {
        this.router.navigate(['/mantenimiento/permisos/accionesperfiltipoestado']);
    }
}
